import request from '@/utils/request'

export default {
  // 获取应用列表
  validateWhitelist(id,params) {
    return request({
      url: `/channel/watch/${id}/validate-whitelist`,
      method: 'get',
      params
    })
  },
  // 获取频道详情
  getChannelDetail(id,params) {
    return request({
      url: `/channel/watch/${id}/detail`,
      method: 'get',
      params
    })
  },
  //验证外部授权
  validateExternalAuth(id,params) {
    return request({
      url: `/channel/watch/${id}/validate-external-auth`,
      method: 'get',
      params
    })
  }
}
